
import { Settings } from '@xeetr/types/models'
import { Controller, useFormContext } from 'react-hook-form'

import LabeledInputSwitch from '../../inputs/LabeledInputSwitch'

const TenantNotification = () => {
  const { control } = useFormContext<Settings>()

  return (
    <div className="space-y-10">
      {/* Email Notifications Section */}
      <section>
        <div className="mb-6">
          <h2 className="text-lg font-semibold">E-Mail Benachrichtigungen</h2>
          <p className="text-muted-foreground text-sm">
            Verwalten Sie E-Mail-Benachrichtigungen für neue Reservierungen und Erinnerungen.
          </p>
        </div>
        <div className="space-y-4">
          <Controller
            name="tenant.settings.notifyOnNewBooking"
            control={control}
            render={({ field }) => (
              <LabeledInputSwitch
                checked={field.value ?? false}
                name={field.name}
                ref={field.ref}
                label="Bei neuer Reservierung per E-Mail benachrichtigen"
                onValueChange={field.onChange}
              />
            )}
          />
          <Controller
            name="tenant.settings.reminderMail"
            control={control}
            render={({ field }) => (
              <LabeledInputSwitch
                checked={field.value ?? false}
                name={field.name}
                ref={field.ref}
                label="Kunden über bevorstehende Reservierung per E-Mail erinnern"
                onValueChange={field.onChange}
              />
            )}
          />
        </div>
      </section>

      {/* Dashboard Notifications Section */}
      <section>
        <div className="mb-6">
          <h2 className="text-lg font-semibold">Dashboard Benachrichtigungen</h2>
          <p className="text-muted-foreground text-sm">
            Erhalten Sie Benachrichtigungen direkt im Management-Dashboard.
          </p>
        </div>
        <div className="space-y-4">
          <Controller
            name="tenant.settings.notifyOnNewBookingDashboard"
            control={control}
            render={({ field }) => (
              <LabeledInputSwitch
                checked={field.value ?? false}
                name={field.name}
                ref={field.ref}
                label="Bei neuer Reservierung im Dashboard benachrichtigen"
                onValueChange={field.onChange}
              />
            )}
          />
        </div>
      </section>
    </div>
  )
}

export default TenantNotification
